import {
  BidAcceptedReasons,
  BidId,
  BidRejectedReasons,
  OfferAcceptedReasons,
  OfferDeclinedReasons,
  OfferId,
  ProjectId,
  type SurveyDomainSelectModel,
  SurveyId,
  SurveyTypes,
  TeamId,
  UserId,
} from '@mntn-dev/domain-types'
import {
  UnhandledUnionError,
  getRandomItem,
  makeRange,
  mapNonEmptyArray,
} from '@mntn-dev/utilities'
import { MockModel } from './mock-model.ts'

const getRandomRating = () =>
  getRandomItem(mapNonEmptyArray(makeRange(5), (i) => i + 1))

export const MockSurveyDetails = (): SurveyDomainSelectModel['details'] => {
  const surveyType = getRandomItem(SurveyTypes)

  switch (surveyType) {
    case 'bid-accepted-by-brand': {
      const bidId = BidId()

      return {
        surveyType,
        bidId,
        responses: {
          reason: getRandomItem(BidAcceptedReasons),
          feedback: `Feedback for ${bidId} ${surveyType}`,
        },
      }
    }

    case 'bid-rejected-by-brand': {
      const bidId = BidId()

      return {
        surveyType,
        bidId,
        responses: {
          reason: getRandomItem(BidRejectedReasons),
          feedback: `Feedback survey ${bidId} ${surveyType}`,
        },
      }
    }

    case 'offer-accepted': {
      const offerId = OfferId()

      return {
        surveyType,
        offerId,
        responses: {
          reason: getRandomItem(OfferAcceptedReasons),
          feedback: `Feedback for ${offerId} ${surveyType}`,
        },
      }
    }

    case 'offer-declined': {
      const offerId = OfferId()

      return {
        surveyType,
        offerId,
        responses: {
          reason: getRandomItem(OfferDeclinedReasons),
          feedback: `Feedback survey ${offerId} ${surveyType}`,
        },
      }
    }

    case 'legacy-quickframe-maker-rating': {
      return {
        surveyType,
        agencyTeamId: TeamId(),
        responses: {
          projectsRated: 1,
          experienceRating: getRandomRating(),
          qualityRating: getRandomRating(),
        },
      }
    }

    case 'project-completed-brand-reviews-maker': {
      const projectId = ProjectId()

      return {
        surveyType,
        projectId,
        responses: {
          finalVideoQualityRating: getRandomRating(),
          makerRating: getRandomRating(),
          feedback: `Feedback for ${projectId} ${surveyType}`,
        },
      }
    }

    case 'project-completed-maker-reviews-brand': {
      const projectId = ProjectId()

      return {
        surveyType,
        projectId,
        responses: {
          brandRating: getRandomRating(),
          feedback: `Feedback for ${projectId} ${surveyType}`,
        },
      }
    }

    default: {
      throw new UnhandledUnionError(surveyType)
    }
  }
}

export const MockSurvey = MockModel<SurveyDomainSelectModel>(
  ({ surveyId = SurveyId(), details = MockSurveyDetails() }) => {
    return {
      surveyId,
      responderId: UserId(),
      details,
    } satisfies SurveyDomainSelectModel
  }
)
